const Icon = require('components/Icon/Icon');
module.exports = Icon;
